import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import EsSelectInstitute from '@/components/settings/esSelectInstitute.vue';
import EsPatientManagementDelegateSettings from '@/components/settings/esPatientManagementDelegateSettings.vue';
import { ItemSelect } from "@/models/share.model";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'esPatientSettings',
  setup(__props) {

const selectedInstitute = ref<ItemSelect>(null);

const selectInstitute = (institute: ItemSelect) => {
  selectedInstitute.value = institute;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(EsSelectInstitute, {
      onSelectInstitute: _cache[0] || (_cache[0] = ($event: any) => (selectInstitute($event))),
      class: "w-full"
    }),
    _createVNode(EsPatientManagementDelegateSettings, { selectedInstitute: selectedInstitute.value }, null, 8, ["selectedInstitute"])
  ], 64))
}
}

})